module.exports = __webpack_public_path__ + "static/media/react.b5120013.svg";